import axios from 'axios';

const getEntidade = () => axios.get('/entidades');

const getEntidades = () => axios.get('/entidades/list');

const updateLogoEntidade = entidade => axios.put(`/entidades/${entidade.id}/logo`, entidade);

export default {
  getEntidade,
  getEntidades,
  updateLogoEntidade,
};
